import { FC } from 'react';

import { Heading, HeadingTagType, Link } from '@purpur/library';

import { useComponentId } from '@telialt/utils/src/hooks';

import { GlobalSmoothScrollStyle, JumpToNavigation } from './TableOfContents.styles';

type Hyperlink = { name: string; href: string };
type Props = { links: Hyperlink[]; headingTitle: string; headingTag: HeadingTagType };

export const TableOfContents: FC<Props> = ({ links, headingTitle, headingTag }) => {
    const headingId = `${useComponentId('table-of-contents')}-heading`;

    if (!links?.length) {
        return null;
    }

    return (
        <JumpToNavigation aria-labelledby={headingId}>
            <Heading id={headingId} tag={headingTag} variant="title-200">
                {headingTitle}
            </Heading>
            <GlobalSmoothScrollStyle />
            <ul>
                {links.map(({ href, name }) => (
                    <li key={href}>
                        <Link variant="standalone" href={href}>
                            {name}
                        </Link>
                    </li>
                ))}
            </ul>
        </JumpToNavigation>
    );
};
